import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const FixIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.3584 13.3567C19.1689 14.546 16.9308 14.4998 13.4992 14.4998C11.2914 14.4998 9.50138 12.7071 9.50024 10.4993C9.50024 7.07001 9.454 4.83065 10.6435 3.64138C11.8329 2.45212 12.3583 2.50027 17.6274 2.50027C18.1366 2.49809 18.3929 3.11389 18.0329 3.47394L15.3199 6.18714C14.6313 6.87582 14.6294 7.99233 15.3181 8.68092C16.0068 9.36952 17.1234 9.36959 17.8122 8.68109L20.5259 5.96855C20.886 5.60859 21.5019 5.86483 21.4997 6.37395C21.4997 11.6422 21.5479 12.1675 20.3584 13.3567Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M13.5 14.5L7.32842 20.6716C6.22386 21.7761 4.433 21.7761 3.32843 20.6716C2.22386 19.567 2.22386 17.7761 3.32843 16.6716L9.5 10.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M5.50896 18.5H5.5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const FixIconSmall: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5742 8.90455C12.7812 9.69741 11.2892 9.66661 9.00143 9.66661C7.52956 9.66661 6.33622 8.47148 6.33546 6.99962C6.33546 4.71342 6.30463 3.22051 7.09763 2.42767C7.89056 1.63483 8.24083 1.66693 11.7536 1.66693C12.093 1.66547 12.2639 2.07601 12.0239 2.31604L10.2152 4.12484C9.75616 4.58396 9.7549 5.3283 10.214 5.78736C10.6732 6.24643 11.4176 6.24648 11.8768 5.78748L13.6859 3.97912C13.926 3.73914 14.3366 3.90997 14.3351 4.24938C14.3351 7.76155 14.3672 8.11175 13.5742 8.90455Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M9.00194 9.66667L4.88755 13.7811C4.15118 14.5174 2.95727 14.5174 2.22089 13.7811C1.48451 13.0447 1.48451 11.8507 2.22089 11.1144L6.33527 7"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M3.67458 12.3333H3.66861"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
